import { Component, Input, OnInit } from '@angular/core';
import { KeyValue } from '../../../../../models/KeyValue';
import { TooltipService } from '../../../../../services/tooltip-service';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';

declare var jQuery;

@Component({
  selector: 'domain-ivt',
  templateUrl: './domain-ivt.html',
  styleUrls: ['./domain-ivt.css']
})
export class DomainIvt implements OnInit {
  @Input() data: any;
  @Input() appName: string;

  tooltipData: KeyValue[];
  barChartData: Array<ChartData>;

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(
    private tooltipService: TooltipService,
    private userService: User
  ) {
    this.tooltipData = this.tooltipService.getMap();
  }

  ngOnInit() {
    setTimeout(fn => {
      jQuery('[data-toggle="tooltip"]').tooltip({ animation: false });
    }, 100);

    if (this?.data?.ivtDistribution?.byMonth) {
      this.barChartData = this?.data?.ivtDistribution?.byMonth;
      this.barChartData.reverse();
    }
  }
}
